import type { TFunction, TOptions } from 'i18next';

const MISSING = '\u0000missing';

/**
 * Looks up copy that may not exist, returning '' when no language has it. `defaultValue: ''`
 * cannot do this: with `returnEmptyString: false` an empty default renders the key instead.
 */
export const translateOptional = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: TFunction<any>,
  key: string,
  options?: TOptions,
): string => {
  const value: string = t(key, { ...options, defaultValue: MISSING });
  return value === MISSING ? '' : value;
};
